import { render, staticRenderFns } from "./activityItem.vue?vue&type=template&id=395ed304"
import script from "./activityItem.vue?vue&type=script&lang=js"
export * from "./activityItem.vue?vue&type=script&lang=js"
import style0 from "./activityItem.vue?vue&type=style&index=0&id=395ed304&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports